<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-12 col-sm-7">
            <h5 class="card-title">PSA</h5>
          </div>
          <div class="col-12 col-sm-5 pt-1">
            <div class="psa-header-actions">
              <p-button type="default" @click="newPsa()" title="PSA hinzufügen" class="mt-0 mr-0 psa-action-btn" v-if="role > 1 && psaRole > 1"><i class="bi bi-plus-circle" style="font-size: 16px;"></i> Hinzufügen</p-button>
              <p-button type="default" @click="openManageTemplates()" title="Vorlagen verwalten" class="mt-0 mr-0 psa-action-btn psa-action-btn--icon" v-if="role == 3"><i class="bi bi-file-earmark-text" style="font-size: 16px;"></i></p-button>
              <p-button type="default" @click="openManageCategories()" title="Kategorien verwalten" class="mt-0 mr-0 psa-action-btn psa-action-btn--icon" v-if="role == 3"><i class="bi bi-gear" style="font-size: 16px;"></i></p-button>
              <p-button type="default" @click="toggleAllCategories" :title="allCategoriesSelected ? 'Alle Kategorien abwählen' : 'Alle Kategorien auswählen'" class="mt-0 mr-0 psa-action-btn psa-action-btn--icon"><i class="bi" :class="allCategoriesSelected ? 'bi-check2-square' : 'bi-square'" style="font-size: 16px;"></i></p-button>
              <el-select v-model="selectedCategories" multiple collapse-tags placeholder="Kategorien wählen" @change="onCategoriesChanged" class="psa-category-select">
                <el-option v-for="category in psaCategories" :value="category.psaCatName" :label="category.psaCatName" :key="category.key"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-4 pb-3 pt-2">
          <div class="col-4">
            <el-statistic title="Einsatzbereit" :value=counterOK group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-4">
            <el-statistic title="Prüfung fällig" :value=counterMaintenance group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-4">
            <el-statistic title="Nicht einsatzbereit" :value=counterNOK group-separator="." :precision="0"></el-statistic>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-6 col-lg-5 ml-auto">
            <el-input v-model="search" placeholder="Suche (Serien-Nr., Eigene Nr., Chargen-Nr., Artikel, Hersteller, Kategorie)" prefix-icon="el-icon-search" clearable></el-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table 
            ref="psaTable"
            :data="filteredPsa" header-row-class-name="text-primary" empty-text="Es konnte keine PSA gefunden werden."
              v-loading="loading"
              :default-sort = "{prop: 'psaSerialNumber', order: 'ascending'}"
              @row-click="showDetails"
              @filter-change="onColumnFilterChange">
              <el-table-column prop="psaSerialNumber" label="Serien-Nr." min-width="130" sortable></el-table-column>
              <el-table-column prop="psaOwnId" label="Eigene Nr." min-width="130" sortable></el-table-column>
              <el-table-column prop="psaManufacturer" label="Hersteller" min-width="120"
                column-key="manufacturer"
                :filters="manufacturerFilters"
                :filtered-value="columnFilters.manufacturer"
                filter-placement="bottom-end"></el-table-column>
              <el-table-column prop="psaItem" label="Artikel"></el-table-column>
              <el-table-column prop="psaStatus" label="Status" min-width="120"
                column-key="status"
                :filters="[{ text: 'Einsatzbereit', value: 'OK' }, { text: 'Prüfung fällig', value: 'maintenance' }, { text: 'Nicht einsatzbereit', value: 'NOK' }]"
                :filtered-value="columnFilters.status"
                filter-placement="bottom-end"
                align="center"
                sortable>
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.psaStatus === 'OK'"
                    type="success"
                    disable-transitions>Einsatzbereit</el-tag>
                  <el-tag
                    v-if="scope.row.psaStatus === 'maintenance'"
                    type="warning"
                    disable-transitions>Prüfung fällig</el-tag>
                  <el-tag
                    v-if="scope.row.psaStatus === 'NOK'"
                    type="danger"
                    disable-transitions>Nicht einsatzbereit</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="psaLastMaintenance" label="Letzte Prüfung" min-width="100"
                column-key="lastMaintenance"
                :filters="lastMaintenanceFilters"
                :filtered-value="columnFilters.lastMaintenance"
                filter-placement="bottom-end"></el-table-column>
              <el-table-column prop="psaNextMaintenance" label="Nächste Prüfung" min-width="100"
                column-key="nextMaintenance"
                :filters="nextMaintenanceFilters"
                :filtered-value="columnFilters.nextMaintenance"
                filter-placement="bottom-end"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="showNewPsaModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">PSA hinzufügen</h5>
      <div class="row">
        <div class="col">
          <label class="pt-1">Vorlage:</label>
          <el-select v-model="newPsaTemplate" placeholder="Ohne Vorlage" clearable @change="templateSelected">
            <el-option v-for="template in psaTemplates" :value=template.psaTemplateName :label=template.psaTemplateName :key=template.key></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Bezeichnung</label>
          <el-input v-model="newPsaName"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Serien-Nummer:</label>
          <el-input v-model="newPsaSerialNumer" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Eigene Nummer:</label>
          <el-input v-model="newPsaOwnId" prefix-icon="el-icon-key" @input="ownIdExists = false" @change="checkOwnIdUnique">
            <el-button slot="append" icon="el-icon-magic-stick" @click="generateOwnId" :loading="generatingOwnId" title="Nächste freie Nummer generieren"></el-button>
          </el-input>
          <el-alert
            v-if="ownIdExists"
            type="error"
            show-icon
            :closable="false"
            class="mt-2"
          >
            Eigene Nummer ist bereits vergeben.
          </el-alert>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Chargen-Nummer:</label>
          <el-input v-model="newPsaBatchNumber" prefix-icon="el-icon-key" clearable></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">GAL-Link:</label>
          <el-input v-model="newPsaGalLink" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Hersteller:</label>
          <el-select v-model="newPsaManufacturer" placeholder="Hersteller auswählen" clearable>
            <el-option v-for="manufacturer in manufacturers" :value=manufacturer :label=manufacturer :key=manufacturer></el-option>
          </el-select>
        </div>
        <div class="col-md">
          <label class="pt-4">Kategorie:</label>
          <el-select v-model="newPsaType" placeholder="Kategorie auswählen" clearable>
            <el-option v-for="cat in psaCategories" :value=cat.psaCatName :label=cat.psaCatName :key=cat.psaCatName></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Herstellung:</label>
          <el-date-picker v-model="newPsaProdDate" type="month" placeholder="Herstellungsdatum" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
        <div class="col-md">
          <label class="pt-4">Inbetriebnahme:</label>
          <el-date-picker v-model="newPsaFirstUse" type="month" placeholder="Inbetriebnahme" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Lebensdauer (Jahre):</label><br>
          <small class="text-muted">ab Herstellung</small><br>
          <el-checkbox v-model="newPsaEOLUnlimited" class="mb-2">unbegrenzt</el-checkbox><br>
          <el-input-number style="text-align: center" v-model="newPsaEOL" :min="1" :max="30" :disabled="newPsaEOLUnlimited"></el-input-number>
        </div>
        <div class="col-md">
          <label class="pt-4">Nutzungsdauer (Jahre):</label><br>
          <small class="text-muted">ab Inbetriebnahme (0 = wie Lebensdauer)</small><br>
          <el-checkbox v-model="newPsaUsageUnlimited" class="mb-2">unbegrenzt</el-checkbox><br>
          <el-input-number style="text-align: center" v-model="newPsaUsage" :min="0" :max="30" :disabled="newPsaUsageUnlimited"></el-input-number>
        </div>
      </div>
      

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showNewPsaModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="addPsa()" :disabled="ownIdExists == true || newPsaName == '' || (newPsaSerialNumer == '' && newPsaOwnId == '') || newPsaManufacturer == '' || newPsaType == ''">Hinzufügen</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showManageCategoriesModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">Kategorien verwalten</h5>
      <div class="row">
        <div class="col">
          <label>Neue Kategorie:</label>
          <el-input v-model="newCategoryName" placeholder="Name der neuen Kategorie">
            <el-button slot="append" icon="el-icon-plus" @click="addCategory" :loading="categoryActionLoading" :disabled="newCategoryName.trim() == ''" title="Hinzufügen"></el-button>
          </el-input>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <label>Bestehende Kategorien:</label>
          <el-table :data="psaCategories" empty-text="Keine Kategorien vorhanden." size="small">
            <el-table-column label="Name">
              <template slot-scope="scope">
                <el-input v-if="editingCategoryKey === scope.row.key" v-model="editingCategoryName" size="small"></el-input>
                <span v-else>{{ scope.row.psaCatName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Aktionen" width="160" align="right">
              <template slot-scope="scope">
                <template v-if="editingCategoryKey === scope.row.key">
                  <el-button type="success" icon="el-icon-check" size="mini" circle @click="saveCategoryRename(scope.row)" :loading="categoryActionLoading" title="Speichern"></el-button>
                  <el-button icon="el-icon-close" size="mini" circle @click="cancelCategoryEdit()" title="Abbrechen"></el-button>
                </template>
                <template v-else>
                  <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="startCategoryEdit(scope.row)" title="Umbenennen"></el-button>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteCategory(scope.row)" :loading="categoryActionLoading" title="Löschen"></el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showManageCategoriesModal=false">Schließen</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showManageTemplatesModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">Vorlagen verwalten</h5>
      <div class="row">
        <div class="col">
          <el-table :data="manageTemplates" empty-text="Keine Vorlagen vorhanden." size="small" @row-click="startTemplateEdit">
            <el-table-column prop="psaTemplateName" label="Name" sortable></el-table-column>
            <el-table-column prop="psaType" label="Kategorie" sortable></el-table-column>
            <el-table-column prop="psaManufacturer" label="Hersteller"></el-table-column>
            <el-table-column label="Aktionen" width="110" align="right">
              <template slot-scope="scope">
                <el-button type="primary" icon="el-icon-edit" size="mini" circle @click.stop="startTemplateEdit(scope.row)" title="Bearbeiten"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click.stop="deleteTemplate(scope.row)" :loading="templateActionLoading" title="Löschen"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showManageTemplatesModal=false">Schließen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="startNewTemplate()">Neue Vorlage</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showEditTemplateModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">{{ editingTemplateKey ? 'Vorlage bearbeiten' : 'Neue Vorlage' }}</h5>
      <div class="row">
        <div class="col">
          <label class="pt-1">Name:</label>
          <el-input v-model="templateForm.name"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Artikel:</label>
          <el-input v-model="templateForm.item"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">GAL-Link:</label>
          <el-input v-model="templateForm.galLink"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Hersteller:</label>
          <el-select v-model="templateForm.manufacturer" placeholder="Hersteller auswählen" clearable>
            <el-option v-for="manufacturer in manufacturers" :value="manufacturer" :label="manufacturer" :key="manufacturer"></el-option>
          </el-select>
        </div>
        <div class="col-md">
          <label class="pt-4">Kategorie:</label>
          <el-select v-model="templateForm.type" placeholder="Kategorie auswählen" clearable>
            <el-option v-for="cat in psaCategories" :value="cat.psaCatName" :label="cat.psaCatName" :key="cat.psaCatName"></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Lebensdauer (Jahre):</label><br>
          <small class="text-muted">ab Herstellung</small><br>
          <el-checkbox v-model="templateForm.eolUnlimited" class="mb-2">unbegrenzt</el-checkbox><br>
          <el-input-number style="text-align: center" v-model="templateForm.eol" :min="1" :max="30" :disabled="templateForm.eolUnlimited"></el-input-number>
        </div>
        <div class="col-md">
          <label class="pt-4">Nutzungsdauer (Jahre):</label><br>
          <small class="text-muted">ab Inbetriebnahme (0 = wie Lebensdauer)</small><br>
          <el-checkbox v-model="templateForm.usageUnlimited" class="mb-2">unbegrenzt</el-checkbox><br>
          <el-input-number style="text-align: center" v-model="templateForm.usage" :min="0" :max="30" :disabled="templateForm.usageUnlimited"></el-input-number>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showEditTemplateModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="saveTemplate()" :loading="templateActionLoading" :disabled="!templateForm.name.trim() || !templateForm.type || !templateForm.manufacturer">Speichern</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Input, InputNumber, Loading, Popover, Tag, Select, Option, Statistic, MessageBox, Checkbox, Button } from "element-ui";
import { Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'
import locations from "../../../../locationStore";
import psaData from "../../../../../psa.json";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)
Vue.use(Statistic)
Vue.use(Button)

const COLUMN_FILTER_KEYS = ["status", "manufacturer", "lastMaintenance", "nextMaintenance"];

function columnFilterStorageKey() {
  const user = store.getters.user;
  const uid = user && user.data && user.data.uid ? user.data.uid : "anonymous";
  return "PsaColumnFilters_" + uid;
}

function loadColumnFilters() {
  const result = {};
  let stored = {};
  try {
    stored = JSON.parse(localStorage.getItem(columnFilterStorageKey()) || "{}") || {};
  } catch (e) {
    stored = {};
  }
  COLUMN_FILTER_KEYS.forEach((k) => {
    result[k] = Array.isArray(stored[k]) ? stored[k] : [];
  });
  return result;
}

export default {
  components: {
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Checkbox.name]: Checkbox,
    SelectLocation,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    MessageBox,
  },

  data() {
    return {
      loading: true,
      psa: [],
      search: "",
      showNewPsaModal: false,
      psaTemplates: [],
      newPsaTemplate: "",
      newPsaName: "",
      newPsaGalLink: "",
      newPsaType: "",
      newPsaManufacturer: "",
      newPsaSerialNumer: "",
      newPsaOwnId: "",
      newPsaBatchNumber: "",
      newPsaFirstUse: "",
      newPsaProdDate: "",
      newPsaEOL: 10,
      newPsaEOLUnlimited: false,
      newPsaUsage: 10,
      newPsaUsageUnlimited: false,
      generatingOwnId: false,
      psaCategories: [],
      selectedCategories: [],
      categoriesInitialized: false,
      columnFilters: loadColumnFilters(),
      ownIdExists: false,
      role: store.getters.userrole,
      psaRole: store.getters.psaRole,
      location: store.getters.userlocation,
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: []
        },
      manufacturers: psaData.manufacturers.map(manufacturer => manufacturer.name),
      showManageCategoriesModal: false,
      newCategoryName: "",
      editingCategoryKey: null,
      editingCategoryName: "",
      categoryActionLoading: false,
      showManageTemplatesModal: false,
      showEditTemplateModal: false,
      manageTemplates: [],
      manageTemplatesUnsub: null,
      editingTemplateKey: null,
      templateForm: {
        name: "",
        item: "",
        galLink: "",
        manufacturer: "",
        type: "",
        eol: 10,
        eolUnlimited: false,
        usage: 10,
        usageUnlimited: false,
      },
      templateActionLoading: false,
    };
  },
  created() {
    if(store.getters.psaRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    }
    moment.locale("de");
    this.loadPsaCategories();
    this.loadPsa();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadPsa();
      }
    );
  },
  beforeDestroy() {
    if (this.manageTemplatesUnsub) {
      this.manageTemplatesUnsub();
      this.manageTemplatesUnsub = null;
    }
  },
  computed: {
    allCategoriesSelected() {
      return this.psaCategories.length > 0 && this.selectedCategories.length === this.psaCategories.length;
    },
    filteredPsa() {
      const s = (this.search || "").toLowerCase().trim();
      const cats = this.selectedCategories;
      const f = this.columnFilters;
      return this.psa.filter((p) => {
        if (cats.length === 0) {
          return false;
        }
        if (!cats.includes(p.psaType)) {
          return false;
        }
        if (f.status.length && !f.status.includes(p.psaStatus)) return false;
        if (f.manufacturer.length && !f.manufacturer.includes(p.psaManufacturer)) return false;
        if (f.lastMaintenance.length && !f.lastMaintenance.includes(p.psaLastMaintenanceKey)) return false;
        if (f.nextMaintenance.length && !f.nextMaintenance.includes(p.psaNextMaintenanceKey)) return false;
        if (!s) return true;
        return (
          (p.psaSerialNumber || "").toString().toLowerCase().includes(s) ||
          (p.psaOwnId || "").toString().toLowerCase().includes(s) ||
          (p.psaBatchNumber || "").toString().toLowerCase().includes(s) ||
          (p.psaManufacturer || "").toLowerCase().includes(s) ||
          (p.psaItem || "").toLowerCase().includes(s) ||
          (p.psaType || "").toLowerCase().includes(s)
        );
      });
    },
    manufacturerFilters() {
      // Keep persisted selections visible so they can be unchecked even if no item matches anymore.
      const values = new Set(this.columnFilters.manufacturer);
      this.psa.forEach((p) => {
        if (p.psaManufacturer) values.add(p.psaManufacturer);
      });
      return Array.from(values)
        .sort((a, b) => a.localeCompare(b, "de"))
        .map((v) => ({ text: v, value: v }));
    },
    lastMaintenanceFilters() {
      return this.monthFilters("psaLastMaintenanceKey", this.columnFilters.lastMaintenance, true);
    },
    nextMaintenanceFilters() {
      return this.monthFilters("psaNextMaintenanceKey", this.columnFilters.nextMaintenance, false);
    },
    counterOK() {
      return this.filteredPsa.filter((x) => x.psaStatus === 'OK').length;
    },
    counterNOK() {
      return this.filteredPsa.filter((x) => x.psaStatus === 'NOK').length;
    },
    counterMaintenance() {
      return this.filteredPsa.filter((x) => x.psaStatus === 'maintenance').length;
    },
  },
  methods: {
    loadPsaCategories() {
      const psaCatRef = db.collection("psaCategories");
      psaCatRef.orderBy("Name").onSnapshot((snapshotChange) => {
        this.psaCategories = [];
        snapshotChange.forEach((doc) => {
          this.psaCategories.push({
            key: doc.id,
            psaCatName: doc.data().Name,
          });
        });
        if (!this.categoriesInitialized && this.psaCategories.length > 0) {
          this.categoriesInitialized = true;
          const allNames = this.psaCategories.map((c) => c.psaCatName);
          const stored = localStorage.SelectedPsaCategories;
          const legacy = localStorage.SelectedPsaCategory;
          if (stored) {
            try {
              const arr = JSON.parse(stored);
              if (Array.isArray(arr)) {
                const filtered = arr.filter((n) => allNames.includes(n));
                this.selectedCategories = filtered.length > 0 ? filtered : allNames.slice();
              } else {
                this.selectedCategories = allNames.slice();
              }
            } catch (e) {
              this.selectedCategories = allNames.slice();
            }
          } else if (legacy && allNames.includes(legacy)) {
            this.selectedCategories = [legacy];
            localStorage.SelectedPsaCategories = JSON.stringify(this.selectedCategories);
            localStorage.removeItem("SelectedPsaCategory");
          } else {
            this.selectedCategories = allNames.slice();
          }
        }
      });
    },
    loadPsa() {
      // get PSA data from firebase
      const psaRef = db.collection("psa");
      psaRef.where('locationID', '==', this.location).where('Status', '!=', "Removed").onSnapshot((snapshotChange) => {
        const psaPromises = [];
        snapshotChange.forEach((doc) => {
          const lastMaintenanceMoment = moment(doc.data().LastMaintenance != null
            ? new Date(doc.data().LastMaintenance.seconds * 1000)
            : new Date('2000-01-01'));
          const lastMaintenance = lastMaintenanceMoment.format("MMM yyyy").toString();
          const lastMaintenanceKey = lastMaintenanceMoment.format("YYYY-MM");
          const nextMaintenanceMoment = moment(doc.data().NextMaintenance != null
            ? new Date(doc.data().NextMaintenance.seconds * 1000)
            : new Date('2000-01-01'));
          const nextMaintenance = nextMaintenanceMoment.format("MMM yyyy").toString();
          const nextMaintenanceKey = nextMaintenanceMoment.format("YYYY-MM");
          var ProdDate = "";
          if(doc.data().ProdDate != null) {
            ProdDate = moment(new Date(doc.data().ProdDate.seconds * 1000)).format("MMM yyyy").toString();
          } else {
            ProdDate = moment(new Date('2000-01-01')).format("MMM yyyy").toString();
          }
          var FirstUse = "";
          if(doc.data().FirstUse != null) {
            FirstUse = moment(new Date(doc.data().FirstUse.seconds * 1000)).format("MMM yyyy").toString();
          } else {
            FirstUse = moment(new Date('2000-01-01')).format("MMM yyyy").toString();
          }
          var status = doc.data().Status;
          const nextMaintenanceDate = doc.data().NextMaintenance
          ? (doc.data().NextMaintenance.toDate ? doc.data().NextMaintenance.toDate() : new Date(doc.data().NextMaintenance))
          : null;
          if (status == 'maintenance') {
            status = "maintenance";
          } else if (status == 'OK' && nextMaintenanceDate && moment().isSameOrAfter(moment(nextMaintenanceDate))) {
            status = "maintenance";
          } else if (status == 'OK' && nextMaintenanceDate && moment().isBefore(moment(nextMaintenanceDate))) {
            status = "OK";
          }

          // Ablegereife (Lebensdauer + Nutzungsdauer) prüfen: wenn eine der
          // beiden Fristen erreicht/überschritten ist, wird der Status auf
          // "maintenance" gesetzt (sofern nicht bereits NOK). Ist keine
          // Nutzungsdauer gesetzt (Usage=0 und nicht unlimited), wird die
          // Lebensdauer-Angabe für die Nutzungsdauer übernommen — aber
          // weiterhin ab Inbetriebnahme gerechnet.
          const prodDateRaw = doc.data().ProdDate
            ? (doc.data().ProdDate.seconds ? new Date(doc.data().ProdDate.seconds * 1000) : new Date(doc.data().ProdDate))
            : null;
          const firstUseRaw = doc.data().FirstUse
            ? (doc.data().FirstUse.seconds ? new Date(doc.data().FirstUse.seconds * 1000) : new Date(doc.data().FirstUse))
            : null;
          const eolYears = doc.data().EOL || 0;
          const eolUnlimited = doc.data().EOLUnlimited || false;
          const rawUsageYears = doc.data().Usage || 0;
          const rawUsageUnlimited = doc.data().UsageUnlimited || false;
          const usageIsUnset = !rawUsageUnlimited && rawUsageYears === 0;
          const usageYears = usageIsUnset ? eolYears : rawUsageYears;
          const usageUnlimited = usageIsUnset ? eolUnlimited : rawUsageUnlimited;
          const ablegereifeUnlimited = eolUnlimited && usageUnlimited;
          // Wenn die effektive Ablegereife unbegrenzt ist, wird ein noch
          // bestehender NOK-Status ("Nicht einsatzbereit") aus früheren
          // Prüfungen für die Anzeige aufgehoben. "Removed" bleibt bestehen.
          if (ablegereifeUnlimited && status === 'NOK') {
            status = 'OK';
          }
          const lifetimeReached = !eolUnlimited && prodDateRaw && eolYears > 0
            && moment().isSameOrAfter(moment(prodDateRaw).add(eolYears, "years"));
          const usageReached = !usageUnlimited && firstUseRaw && usageYears > 0
            && moment().isSameOrAfter(moment(firstUseRaw).add(usageYears, "years"));
          if ((lifetimeReached || usageReached) && status !== 'NOK') {
            status = 'maintenance';
          }

          // Check subcomponents in subcollection `components` for EOLDate reached (on or before today)
          const compRef = db.collection('psa').doc(doc.id).collection('components');
          const psaPromise = compRef.get().then((compSnap) => {
            let hasEOLReached = false;
            compSnap.forEach((cdoc) => {
              const cdata = cdoc.data();
              // Skip removed components if schema provides such flags
              if ((cdata && cdata.Status === 'Removed') || (cdata && cdata.Removed === true)) {
                return;
              }
              let eolDate = null;
              if (cdata && cdata.EOLDate) {
                if (cdata.EOLDate.seconds) {
                  eolDate = new Date(cdata.EOLDate.seconds * 1000);
                } else {
                  // Fallback: attempt to construct Date directly
                  eolDate = new Date(cdata.EOLDate);
                }
              }
              if (eolDate && moment().isSameOrAfter(moment(eolDate))) {
                hasEOLReached = true;
              }
            });
            // If any subcomponent reached EOL, set to maintenance unless already NOK
            if (hasEOLReached && status !== 'NOK') {
              status = 'maintenance';
            }
            return {
              key: doc.id,
              psaType: doc.data().Type,
              psaManufacturer: doc.data().Manufacturer,
              psaItem: doc.data().Item,
              psaSerialNumber: doc.data().SerialNumber,
              psaOwnId: doc.data().OwnId,
              psaBatchNumber: doc.data().BatchNumber || "",
              psaProdDate: ProdDate,
              psaFirstUse: FirstUse,
              psaLastMaintenance: lastMaintenance,
              psaNextMaintenance: nextMaintenance,
              psaLastMaintenanceKey: lastMaintenanceKey,
              psaNextMaintenanceKey: nextMaintenanceKey,
              psaStatus: status,
            };
          }).catch(() => {
            // If components fetch fails, return the PSA without subcomponent-based override
            return {
              key: doc.id,
              psaType: doc.data().Type,
              psaManufacturer: doc.data().Manufacturer,
              psaItem: doc.data().Item,
              psaSerialNumber: doc.data().SerialNumber,
              psaOwnId: doc.data().OwnId,
              psaBatchNumber: doc.data().BatchNumber || "",
              psaProdDate: ProdDate,
              psaFirstUse: FirstUse,
              psaLastMaintenance: lastMaintenance,
              psaNextMaintenance: nextMaintenance,
              psaLastMaintenanceKey: lastMaintenanceKey,
              psaNextMaintenanceKey: nextMaintenanceKey,
              psaStatus: status,
            };
          });
          psaPromises.push(psaPromise);
        });

        Promise.all(psaPromises).then((items) => {
          this.psa = items;
          this.loading = false;
        });
      });
    },
    showDetails(row, column) {
      if (column.property) {
        router.push({ name: "PsaDetails", params: { psaId: row.key } });
      }
    },
    monthFilters(keyProp, selected, descending) {
      const values = new Set(selected);
      this.psa.forEach((p) => {
        if (p[keyProp]) values.add(p[keyProp]);
      });
      const sorted = Array.from(values).sort();
      if (descending) sorted.reverse();
      return sorted.map((v) => ({ text: moment(v, "YYYY-MM").format("MMM yyyy"), value: v }));
    },
    onColumnFilterChange(filters) {
      Object.keys(filters).forEach((k) => {
        if (COLUMN_FILTER_KEYS.includes(k)) {
          this.columnFilters[k] = filters[k] || [];
        }
      });
      localStorage.setItem(columnFilterStorageKey(), JSON.stringify(this.columnFilters));
    },
    updateLocation(loc) {
      this.location = loc
      this.loadPsa()
    },
    updatePsaCategory(cat) {
      // legacy stub kept in case external callers reference it
      this.onCategoriesChanged();
    },
    onCategoriesChanged() {
      localStorage.SelectedPsaCategories = JSON.stringify(this.selectedCategories);
    },
    toggleAllCategories() {
      if (this.allCategoriesSelected) {
        this.selectedCategories = [];
      } else {
        this.selectedCategories = this.psaCategories.map((c) => c.psaCatName);
      }
      this.onCategoriesChanged();
    },
    newPsa() {
      this.newPsaTemplate = "";
      this.newPsaSerialNumer = "";
      this.newPsaOwnId = "";
      this.newPsaBatchNumber = "";
      this.newPsaFirstUse = "";
      this.newPsaProdDate = "";
      this.newPsaEOLUnlimited = false;
      this.newPsaEOL = 10;
      this.newPsaUsageUnlimited = false;
      this.newPsaUsage = 10;
      this.ownIdExists = false;
      this.showNewPsaModal = true;
      const psaTemplateRef = db.collection("psaTemplates");
      psaTemplateRef.orderBy("Name").onSnapshot((snapshotChange) => {
        this.psaTemplates = [];
        snapshotChange.forEach((doc) => {
          this.psaTemplates.push({
            key: doc.id,
            psaTemplateName: doc.data().Name,
            psaType: doc.data().Type,
            psaManufacturer: doc.data().Manufacturer,
            psaItem: doc.data().Item,
            psaGalLink: doc.data().GalLink,
            psaEOL: doc.data().EOL,
            psaEOLUnlimited: doc.data().EOLUnlimited || false,
            psaUsage: doc.data().Usage,
            psaUsageUnlimited: doc.data().UsageUnlimited || false,
          });
        });
      });
    },
    templateSelected() {
      const selectedTemplate = this.psaTemplates.find(t => t.psaTemplateName == this.newPsaTemplate);
      if(selectedTemplate) {
        this.newPsaType = selectedTemplate.psaType;
        this.newPsaManufacturer = selectedTemplate.psaManufacturer;
        this.newPsaName = selectedTemplate.psaItem;
        this.newPsaGalLink = selectedTemplate.psaGalLink;
        if (selectedTemplate.psaEOL === -1 || selectedTemplate.psaEOLUnlimited) {
          this.newPsaEOLUnlimited = true;
          this.newPsaEOL = 10;
        } else {
          this.newPsaEOLUnlimited = false;
          this.newPsaEOL = selectedTemplate.psaEOL || 10;
        }
        if (selectedTemplate.psaUsage === -1 || selectedTemplate.psaUsageUnlimited) {
          this.newPsaUsageUnlimited = true;
          this.newPsaUsage = 10;
        } else {
          this.newPsaUsageUnlimited = false;
          this.newPsaUsage = selectedTemplate.psaUsage || 10;
        }
      } else {
        this.newPsaType = "";
        this.newPsaManufacturer = "";
        this.newPsaName = "";
        this.newPsaGalLink = "";
        this.newPsaEOL = 10;
        this.newPsaEOLUnlimited = false;
        this.newPsaUsage = 10;
        this.newPsaUsageUnlimited = false;
      }
    },
    addPsa() {
      console.log(this.newPsaTemplate);
      const psaRef = db.collection("psa");
      const prodDate = this.newPsaProdDate ? new Date(this.newPsaProdDate) : null;
      const firstUse = this.newPsaFirstUse ? new Date(this.newPsaFirstUse) : null;
      const lastMaintenance = firstUse;
      const nextMaintenance = firstUse ? moment(this.newPsaFirstUse).add(1, "years").toDate() : null;
      psaRef.add({
        Type: this.newPsaType,
        Manufacturer: this.newPsaManufacturer,
        Item: this.newPsaName,
        GalLink: this.newPsaGalLink,
        SerialNumber: this.newPsaSerialNumer,
        OwnId: this.newPsaOwnId,
        BatchNumber: this.newPsaBatchNumber || "",
        ProdDate: prodDate,
        FirstUse: firstUse,
        LastMaintenance: lastMaintenance,
        NextMaintenance: nextMaintenance,
        EOL: this.newPsaEOLUnlimited ? 0 : this.newPsaEOL,
        EOLUnlimited: this.newPsaEOLUnlimited,
        Usage: this.newPsaUsageUnlimited ? 0 : this.newPsaUsage,
        UsageUnlimited: this.newPsaUsageUnlimited,
        Status: 'OK',
        locationID: this.location,
      }).then(() => {
        this.showNewPsaModal = false;
        this.newPsaTemplate = "";
        this.newPsaSerialNumer = "";
        this.newPsaOwnId = "";
        this.newPsaBatchNumber = "";
        this.newPsaFirstUse = "";
        this.newPsaProdDate = "";
        this.$notify({
          message: "PSA wurde erfolgreich hinzugefügt!",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
        this.loadPsa();
      }).catch((error) => {
        this.$notify({
          message: "Fehler beim Hinzufügen der PSA: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      });
    },
    checkOwnIdUnique() {
      if(this.newPsaOwnId.trim() === "") {
        this.ownIdExists = false;
        return;
      }
      const existing = this.psa.find(p => p.psaOwnId === this.newPsaOwnId.trim());
      this.ownIdExists = !!existing;
    },
    async generateOwnId() {
      this.generatingOwnId = true;
      try {
        const snap = await db.collection("psa")
          .where('locationID', '==', this.location)
          .get();
        const usedNumbers = new Set();
        snap.forEach((doc) => {
          const ownId = doc.data().OwnId;
          if (ownId !== undefined && ownId !== null && ownId !== "") {
            const n = parseInt(String(ownId).trim(), 10);
            if (!isNaN(n)) {
              usedNumbers.add(n);
            }
          }
        });
        let next = 1000;
        while (usedNumbers.has(next)) {
          next++;
        }
        this.newPsaOwnId = String(next);
        this.ownIdExists = false;
      } catch (error) {
        this.$notify({
          message: "Fehler beim Generieren der Nummer: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.generatingOwnId = false;
      }
    },
    openManageCategories() {
      this.newCategoryName = "";
      this.editingCategoryKey = null;
      this.editingCategoryName = "";
      this.showManageCategoriesModal = true;
    },
    async addCategory() {
      const name = this.newCategoryName.trim();
      if (!name) return;
      const exists = this.psaCategories.find(c => c.psaCatName.toLowerCase() === name.toLowerCase());
      if (exists) {
        this.$notify({
          message: "Eine Kategorie mit diesem Namen existiert bereits.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "warning",
          showClose: true,
          timeout: 5000,
        });
        return;
      }
      this.categoryActionLoading = true;
      try {
        await db.collection("psaCategories").add({ Name: name });
        this.newCategoryName = "";
        this.$notify({
          message: "Kategorie wurde hinzugefügt.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Hinzufügen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.categoryActionLoading = false;
      }
    },
    startCategoryEdit(row) {
      this.editingCategoryKey = row.key;
      this.editingCategoryName = row.psaCatName;
    },
    cancelCategoryEdit() {
      this.editingCategoryKey = null;
      this.editingCategoryName = "";
    },
    async saveCategoryRename(row) {
      const newName = this.editingCategoryName.trim();
      const oldName = row.psaCatName;
      if (!newName || newName === oldName) {
        this.cancelCategoryEdit();
        return;
      }
      const exists = this.psaCategories.find(c => c.key !== row.key && c.psaCatName.toLowerCase() === newName.toLowerCase());
      if (exists) {
        this.$notify({
          message: "Eine Kategorie mit diesem Namen existiert bereits.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "warning",
          showClose: true,
          timeout: 5000,
        });
        return;
      }
      this.categoryActionLoading = true;
      try {
        await db.collection("psaCategories").doc(row.key).update({ Name: newName });
        // Update all PSA items (location-independent) that reference the old category name
        const psaSnap = await db.collection("psa").where('Type', '==', oldName).get();
        const updates = [];
        let batch = db.batch();
        let count = 0;
        psaSnap.forEach((doc) => {
          batch.update(doc.ref, { Type: newName });
          count++;
          if (count % 400 === 0) {
            updates.push(batch.commit());
            batch = db.batch();
          }
        });
        if (count % 400 !== 0) {
          updates.push(batch.commit());
        }
        // Also update PSA templates referencing this category
        const tplSnap = await db.collection("psaTemplates").where('Type', '==', oldName).get();
        let tplBatch = db.batch();
        let tplCount = 0;
        tplSnap.forEach((doc) => {
          tplBatch.update(doc.ref, { Type: newName });
          tplCount++;
        });
        if (tplCount > 0) {
          updates.push(tplBatch.commit());
        }
        await Promise.all(updates);
        const idx = this.selectedCategories.indexOf(oldName);
        if (idx !== -1) {
          this.selectedCategories.splice(idx, 1, newName);
          localStorage.SelectedPsaCategories = JSON.stringify(this.selectedCategories);
        }
        this.cancelCategoryEdit();
        this.$notify({
          message: "Kategorie wurde umbenannt.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Umbenennen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.categoryActionLoading = false;
      }
    },
    async deleteCategory(row) {
      try {
        await MessageBox.confirm(
          `Soll die Kategorie "${row.psaCatName}" wirklich gelöscht werden?`,
          "Kategorie löschen",
          {
            confirmButtonText: "Löschen",
            cancelButtonText: "Abbrechen",
            type: "warning",
          }
        );
      } catch (e) {
        return;
      }
      this.categoryActionLoading = true;
      try {
        // Check for visible (non-removed) PSA items in any location
        const psaSnap = await db.collection("psa").where('Type', '==', row.psaCatName).get();
        let visibleCount = 0;
        psaSnap.forEach((doc) => {
          if (doc.data().Status !== "Removed") {
            visibleCount++;
          }
        });
        if (visibleCount > 0) {
          this.$notify({
            message: `Die Kategorie kann nicht gelöscht werden, da ihr noch ${visibleCount} sichtbare PSA-Einträge zugeordnet sind.`,
            icon: "fa fa-exclamation-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "warning",
            showClose: true,
            timeout: 6000,
          });
          return;
        }
        await db.collection("psaCategories").doc(row.key).delete();
        const idx = this.selectedCategories.indexOf(row.psaCatName);
        if (idx !== -1) {
          this.selectedCategories.splice(idx, 1);
          localStorage.SelectedPsaCategories = JSON.stringify(this.selectedCategories);
        }
        this.$notify({
          message: "Kategorie wurde gelöscht.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Löschen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.categoryActionLoading = false;
      }
    },
    openManageTemplates() {
      this.showManageTemplatesModal = true;
      if (this.manageTemplatesUnsub) {
        this.manageTemplatesUnsub();
      }
      this.manageTemplatesUnsub = db.collection("psaTemplates").orderBy("Name").onSnapshot((snap) => {
        this.manageTemplates = [];
        snap.forEach((doc) => {
          this.manageTemplates.push({
            key: doc.id,
            psaTemplateName: doc.data().Name,
            psaType: doc.data().Type,
            psaManufacturer: doc.data().Manufacturer,
            psaItem: doc.data().Item,
            psaGalLink: doc.data().GalLink,
            psaEOL: doc.data().EOL,
            psaEOLUnlimited: doc.data().EOLUnlimited || false,
            psaUsage: doc.data().Usage,
            psaUsageUnlimited: doc.data().UsageUnlimited || false,
          });
        });
      });
    },
    resetTemplateForm() {
      this.templateForm = {
        name: "",
        item: "",
        galLink: "",
        manufacturer: "",
        type: "",
        eol: 10,
        eolUnlimited: false,
        usage: 10,
        usageUnlimited: false,
      };
      this.editingTemplateKey = null;
    },
    startNewTemplate() {
      this.resetTemplateForm();
      this.showEditTemplateModal = true;
    },
    startTemplateEdit(row) {
      this.editingTemplateKey = row.key;
      this.templateForm = {
        name: row.psaTemplateName || "",
        item: row.psaItem || "",
        galLink: row.psaGalLink || "",
        manufacturer: row.psaManufacturer || "",
        type: row.psaType || "",
        eol: (row.psaEOL && row.psaEOL > 0) ? row.psaEOL : 10,
        eolUnlimited: row.psaEOLUnlimited === true || row.psaEOL === -1 || row.psaEOL === 0,
        usage: (row.psaUsage && row.psaUsage > 0) ? row.psaUsage : 10,
        usageUnlimited: row.psaUsageUnlimited === true || row.psaUsage === -1 || row.psaUsage === 0 || row.psaUsage === undefined || row.psaUsage === null,
      };
      this.showEditTemplateModal = true;
    },
    async saveTemplate() {
      const name = this.templateForm.name.trim();
      if (!name || !this.templateForm.type || !this.templateForm.manufacturer) return;
      // Check name uniqueness
      const exists = this.manageTemplates.find(t => t.key !== this.editingTemplateKey && (t.psaTemplateName || "").toLowerCase() === name.toLowerCase());
      if (exists) {
        this.$notify({
          message: "Eine Vorlage mit diesem Namen existiert bereits.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "warning",
          showClose: true,
          timeout: 5000,
        });
        return;
      }
      this.templateActionLoading = true;
      const payload = {
        Name: name,
        Item: this.templateForm.item || "",
        GalLink: this.templateForm.galLink || "",
        Manufacturer: this.templateForm.manufacturer,
        Type: this.templateForm.type,
        EOL: this.templateForm.eolUnlimited ? 0 : this.templateForm.eol,
        EOLUnlimited: this.templateForm.eolUnlimited,
        Usage: this.templateForm.usageUnlimited ? 0 : this.templateForm.usage,
        UsageUnlimited: this.templateForm.usageUnlimited,
      };
      try {
        if (this.editingTemplateKey) {
          await db.collection("psaTemplates").doc(this.editingTemplateKey).update(payload);
        } else {
          await db.collection("psaTemplates").add(payload);
        }
        this.showEditTemplateModal = false;
        this.resetTemplateForm();
        this.$notify({
          message: "Vorlage wurde gespeichert.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Speichern: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.templateActionLoading = false;
      }
    },
    async deleteTemplate(row) {
      try {
        await MessageBox.confirm(
          `Soll die Vorlage "${row.psaTemplateName}" wirklich gelöscht werden?`,
          "Vorlage löschen",
          {
            confirmButtonText: "Löschen",
            cancelButtonText: "Abbrechen",
            type: "warning",
          }
        );
      } catch (e) {
        return;
      }
      this.templateActionLoading = true;
      try {
        await db.collection("psaTemplates").doc(row.key).delete();
        this.$notify({
          message: "Vorlage wurde gelöscht.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Löschen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.templateActionLoading = false;
      }
    },
  },
};
</script>
<style>
.el-tag {
  color: white !important;
}
.psa-header-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.psa-header-actions .psa-action-btn {
  flex: 0 0 auto;
  margin-top: 0;
  margin-bottom: 0;
}
.psa-header-actions .psa-category-select {
  flex: 1 1 auto;
  min-width: 0;
}
.psa-header-actions .psa-category-select .el-input__inner {
  width: 100%;
}
.el-statistic .con .title,
.el-statistic .head,
.el-statistic .title {
  white-space: normal !important;
  word-break: keep-all !important;
  overflow-wrap: normal !important;
  hyphens: none !important;
}
@media (max-width: 575.98px) {
  .psa-header-actions {
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 6px;
  }
  .psa-header-actions .psa-action-btn {
    flex: 1 1 0;
    min-width: 0;
    white-space: nowrap;
  }
  .psa-header-actions .psa-action-btn--icon {
    flex: 0 0 auto;
    padding-left: 14px;
    padding-right: 14px;
  }
  .psa-header-actions .psa-category-select {
    flex: 1 1 100%;
    order: 10;
  }
  .el-statistic .con .title,
  .el-statistic .head,
  .el-statistic .title {
    font-size: 12px;
  }
}
</style>